__turbopack_context__.v({
  "narrow": "MoneyPostTemplate-module__-yMIbG__narrow",
  "simpleLayout": "MoneyPostTemplate-module__-yMIbG__simpleLayout",
  "wrapper": "MoneyPostTemplate-module__-yMIbG__wrapper",
});
